module.exports = __webpack_public_path__ + "static/media/3 realistic growling bear tattoo black and grey realism.1280x1707.92c5f4ad.webp";